module.exports = __webpack_public_path__ + "img/error.fc52d358.png";